
export const initScrollDown = () => {
  // Document CLICK
  document.addEventListener("click", onDocClick, false)
}

// ##########################
// ### Doc event handlers ###
// Doc click
const onDocClick = (e) => {
  if (e.target.classList.contains("scroll-down")) {
    e.preventDefault()
    handleScrollDown()
  } else if (e.target.classList.contains("scroll-to")) {
    e.preventDefault()
    handleScrollTo(e.target)
  }

}

const handleScrollDown = () => {
  animateScroll(window.innerHeight - 70)
}

const handleScrollTo = (el) => {
  const selector = el.getAttribute("href")
  const target = selector ? document.querySelector(selector) : null
  if (target) {
    const rect = target.getBoundingClientRect()
    animateScroll(rect.top + window.scrollY - 70)
  }
}

const animateScroll = (top) => {
  window.scroll({
    behavior: 'smooth',
    left: 0,
    top: top
  });
}